import { render, staticRenderFns } from "./OpportunitiesListModal.vue?vue&type=template&id=36497db4&"
import script from "./OpportunitiesListModal.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports